exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modalDatePicker___1vGpF {\n  margin-top: 2px;\n  width: 150px;\n}\n.modalDatePicker___1vGpF > .DayPicker {\n  min-width: 279px;\n}\n.modalDatePicker___1vGpF .error-message {\n  min-width: 160px;\n  display: inline-block;\n}\n", ""]);

// exports
exports.locals = {
	"modalDatePicker": "modalDatePicker___1vGpF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/common/modals/WeddingDateModal/WeddingDateModal.module.less
// module id = 2398
// module chunks = 71